import { Component, Input, OnInit } from '@angular/core';
import { AreasAnualesModel } from 'src/app/model/FaseAnual.model';

@Component({
  selector: 'app-area-anual',
  templateUrl: './area-anual.component.html',
  styleUrls: ['./area-anual.component.css']
})
export class AreaAnualComponent implements OnInit {

  @Input() areaData : AreasAnualesModel;
  @Input() estadoAnio : number;

  cargando: boolean;
  readonly: boolean = false;

  public isCollapsed = true;

  constructor() { }

  ngOnInit(): void {
    this.cargaInicial();
  }
  cargaInicial(){
    if (this.estadoAnio !=0) {
      this.readonly = true;
    }
  }
}
